<template>
  <div class="hero-section">
    <div class="hero-section__cover-wrapper rounded-t-20">
      <v-img
        class="rounded-t-20"
        :aspect-ratio="isMobile ? 4 / 3 : 3 / 1"
        :src="isMobile ? lpuBranding?.cover_mobile?.url : lpuBranding?.cover_desktop?.url"
        contain
      >
        <template #placeholder>
          <div class="bg-lpu-branding-color-primary h-100" />
        </template>
      </v-img>
      <LpuLogo
        class="hero-section__logo"
        :lpu="lpu"
      />
      <VideoCard
        v-if="lpuVideoCard?.video_path?.url"
        class="hero-section__video-card"
        :video-url="lpuVideoCard.video_path.url"
        :video-uuid="lpuVideoCard.uuid"
      />
      <div class="hero-section__lpu-actions">
        <LpuFavouriteBtn
          :lpu-id="lpu.id"
        />
        <LpuShareBtn
          :lpu="lpu"
        />
      </div>
    </div>
    <div class="hero-section__info rounded-20">
      <LpuHeadline
        :lpu="lpu"
      />
      <TrustBadges
        :lpu="lpu"
      />
      <RatingCard
        :stars="lpu.stars ?? 0"
        :allrates="lpu.allrates"
      />
      <LeaveRateBtn
        :lpu-id="lpu.id"
        :is-closed="lpu.closed"
        class="w-100 mt-1"
      />
      <div class="d-flex flex-column gr-4 my-4">
        <TownLocation
          :town="lpu.town"
        />
        <LpuType
          :lpu="lpu"
        />
        <LpuMistakeBtn
          v-if="!lpu.closed"
          :lpu-id="lpu.id"
        />
      </div>

      <LpuDoctors
        :lpu="lpu"
      />
      <LpuPrices
        :lpu="lpu"
        :synonym-prices-count="synonymPricesCount"
      />
      <LpuAddress
        :lpu="lpu"
      />
      <WorkSchedule
        :lpu="lpu"
      />
      <LpuPhone
        :lpu="lpu"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import type { Lpu, LpuBranding, LpuVideoCard } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import LeaveRateBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LeaveRateBtn.vue'
import LpuAddress from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAddress.vue'
import LpuDoctors from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuDoctors.vue'
import LpuFavouriteBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuFavouriteBtn.vue'
import LpuHeadline from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuHeadline.vue'
import LpuLogo from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuLogo.vue'
import LpuMistakeBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuMistakeBtn.vue'
import LpuPhone from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuPhone.vue'
import LpuPrices from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuPrices.vue'
import LpuShareBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuShareBtn.vue'
import LpuType from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAffiliation.vue'
import RatingCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/RatingCard.vue'
import TownLocation from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TownLocation.vue'
import TrustBadges from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TrustBadges/TrustBadges.vue'
import VideoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/VideoCard/VideoCard.vue'
import WorkSchedule from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/WorkSchedule.vue'

defineProps<{
  lpuBranding?: LpuBranding
  lpu: Lpu
  lpuVideoCard?: LpuVideoCard
  synonymPricesCount?: number
}>()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.hero-section {
  position: relative;
  z-index: 1; /* Нужно, т.к. всплывашки перекрываются элементами */

  &__cover-wrapper {
    margin-bottom: -40px;
    position: relative;
  }

  &__logo {
    position: absolute;
    top: 16px;
    left: 16px;
  }

  &__video-card {
    position: absolute;
    left: 16px;
    bottom: 52px;
  }

  &__info {
    background-color: #F3F6FAE5;
    padding: 16px;
    position: relative;
    row-gap: 12px;
    display: flex;
    flex-direction: column;
    backdrop-filter: blur(17px);
  }

  &__lpu-actions {
    display: flex;
    column-gap: 4px;
    position: absolute;
    top: 12px;
    right: 16px;
  }
}
</style>
